var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"MobileHeader"},[_c('div',{staticClass:"left"},[_vm._t("arrowLeft")],2),_c('div',{staticClass:"text"},[_vm._t("title")],2),_c('div',{staticClass:"right"},[_vm._t("button")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }